// extracted by mini-css-extract-plugin
export var apiV2IpRanges = "api-v2-ip-ranges_Kumw2HlYwCfeVnPj8TNE";
export var apiV2IpRangesError = "api-v2-ip-ranges__error_ZkkTOEVHrhH_3E2q0F7w";